import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {products} from '@modules/constants-enumerate';

const productIcons = {
  [products.MATH_ACADEMY]: require('@assets/images/mathmastery/app-icon.webp'),
  [products.MY_MATH_ACADEMY]: require('@assets/images/my_math_academy/app-icon.webp'),
  [products.READING_MASTERY]: require('@assets/images/readingmastery/mra-color.webp'),
  [products.MY_READING_ACADEMY]: require('@assets/images/my_reading_academy/app-icon.webp'),
  [products.MY_READING_ACADEMY_ES]: require('@assets/images/my_reading_academy_es/app-icon.webp'),
  [products.ABCMOUSE]: require('@assets/images/abcmouse/app-icon.webp'),
  [products.ABCMOUSE_ENGLISH]: require('@assets/images/abcmouse_english/app-icon.webp'),
  [products.READINGIQ]: require('@assets/images/readingiq/app-icon.webp'),
};

/**
 * @summary ProductIcon
 * @extends {AoflElement}
 */
@customElement('product-icon')
class ProductIcon extends AoflElement {
  /**
   * Creates an instance of ProductIcon.
   */
  constructor() {
    super();
  }

  /**
   * @readonly
   */
  static is = 'product-icon';

  @property({type: String, property: true})
  product = '';

  image() {
    return productIcons[this.product];
  }

  /**
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default ProductIcon;

export {productIcons};
